const ErrorPage=()=>{
    return(
        <div className="error-page" style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>
            <h1>404 Page not found 😄 </h1>
        </div>
    )
}

export default ErrorPage;